// @flow
import * as React from 'react';

import { StyledButton, StyledButtonTransparentWhite } from '@styles/buttons';
import type { State as loginState } from '@screens/SignIn/types';
import { withTranslation } from 'react-i18next';

import { connect } from 'react-redux';

import { useBreakpoint } from '@hooks';

import type { I18nProps, GlobalState } from '@globalTypes';
import {
  StyledLoginForm, StyledInput, StyledButtonsContainer, StyledErrorMessage
} from './styles';

type Props = {
  doLogin: Function,
  login: loginState
} & I18nProps;

const LoginForm = ({ doLogin, login, t }: Props): React.Node => {
  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');
  const isMobile = useBreakpoint('mobile', 'desktop');
  const isError: boolean = typeof login.error !== 'undefined';

  const ButtonLogin = isMobile ? StyledButtonTransparentWhite : StyledButton;
  const handleSubmit = (e) => {
    if (username && password) {
      e.preventDefault();
      doLogin(username, password);
    }

    return false;
  };

  return (
    <StyledLoginForm onSubmit={handleSubmit}>
      <StyledInput
        placeholder={`${t('Email')}...`}
        type="text"
        value={username}
        onChange={event => setUsername(event.target.value)}
        error={isError}
        required
      />

      <StyledInput
        placeholder={`${t('Password')}...`}
        type="password"
        value={password}
        onChange={event => setPassword(event.target.value)}
        error={isError}
        required
      />

      {isError && <StyledErrorMessage>{t('LoginError')}</StyledErrorMessage>}

      <StyledButtonsContainer>
        <ButtonLogin full disabled={login.requesting} type="submit">
          {t('Login')}
        </ButtonLogin>
        {/* <ButtonLinkForgotPassword data-prevent-dropdown-toggle="true"
            onClick={onForgotPassword}>
          <span className="underline">{t('ForgotPassword.Link')}</span>
        </ButtonLinkForgotPassword> */}
      </StyledButtonsContainer>
    </StyledLoginForm>
  );
};

const mapStateToProps = ({ login }: GlobalState): {} => ({ login });

export default connect(mapStateToProps)(withTranslation('Login')(LoginForm));
